/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { faShield } from '@fortawesome/pro-solid-svg-icons';
import {
  selectTagList,
} from '../../../../../../redux/slices/tagListSlice/tagListSlice';
import SortableTableHeader
  from '../../../../../common/SortableTableHeader/SortableTableHeader';
import TagListRow from './TagListRow/TagListRow';
import tagType from '../../../../../../utility/types/tagType';

const columnHeaders = [
  { label: 'Tag', sortType: 'name' },
  { label: 'Alerts', sortType: 'alertCount' },
  { label: 'Devices', sortType: 'deviceCount' },
];

function TagListTable() {
  const tagList = useSelector(selectTagList);
  const [sortCol, setSortCol] = useState('');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [sortedList, setSortedList] = useState(tagList);

  const handleSetSortingOrder = (colName, order) => {
    setSortCol(colName);
    setSortOrder(order);
  };
  useEffect(() => {
    const sorted = [...tagList].sort((a, b) => {
      const itemA = a[sortCol];
      const itemB = b[sortCol];
      if (sortOrder === 'ASC') {
        if (itemA < itemB) {
          return -1;
        }
        if (itemA > itemB) {
          return 1;
        }
      } else {
        if (itemA > itemB) {
          return -1;
        }
        if (itemA < itemB) {
          return 1;
        }
      }
      return 0;
    });
    setSortedList(sorted);
  }, [sortCol, sortOrder, tagList]);

  return (
    <table
      className="table table-hover table-sm table-condensed table-striped my-1"
    >
      <thead className="thead-light">
        <tr>
          <th
            style={{ width: '3.5rem' }}
            className="text-right"
          >
            {' '}
          </th>

          {columnHeaders.map((col) => (
            <React.Fragment key={col.label}>
              <SortableTableHeader
                onAscClick={
                () => handleSetSortingOrder(col.sortType, 'ASC')
              }
                onDescClick={() => handleSetSortingOrder(col.sortType, 'DES')}
                label={col.label}
                isSelected={col.sortType === sortCol}
              />
            </React.Fragment>
          ))}

          <th className="thead-light">
            {' '}
          </th>
        </tr>
      </thead>
      <tbody>

        {sortedList.length > 0 && sortedList.map((tag, index) => (
          <React.Fragment key={index}>
            <TagListRow
              tag={tag}
              icon={tag.type === tagType.PRE_DEFINED ? faShield : null}
              iconTooltip={tag.type === tagType.PRE_DEFINED ? 'Predefined tag'
                : null}
            />
          </React.Fragment>
        ))}

      </tbody>
    </table>
  );
}

export default TagListTable;
